import * as React from 'react';

export function ResultsGridCornerMask(): React.ReactElement {
  return (
    <div className="absolute top-0" style={{ left: '100%' }}>
      <svg className="fill-white" width="8" height="36" viewBox="0 0 8 36">
        <path
          fillRule="evenodd"
          d="M8 0a4 4 0 00-3.995 3.8L4 4v28a4 4 0 003.8 3.995L8 36H0V0h8z"
        />
      </svg>
    </div>
  );
}
